import { CMSHeader } from '@travelwin/cms/types';
import { useTranslation } from 'react-i18next';

import { NavItem } from '../interfaces/NavBar';
import { useAboutUsItems } from './useAboutUsItems';
import { useCmsHeaderItems } from './useCmsHeaderItems';
import { useMyEsimItem } from './useESIMItem';
import { useHelpItems } from './useHelpItems';
import { useMyAccountItem } from './useMyAccountItem';
import { useStoreLocatorItem } from './useStoreLocatorItem';

export const useNavbarItems = (): {
  navbarItems: NavItem[];
  burgerMenuItems: NavItem[];
  contactBarItems: NavItem[];
  brandLogo?: CMSHeader['logo'];
  whatsAppContactButton?: CMSHeader['whatsAppContactButton'];
} => {
  const helpItem = useHelpItems();
  const aboutUsItem = useAboutUsItems();
  const myESIM = useMyEsimItem();
  const myAccount = useMyAccountItem();
  const storeLocator = useStoreLocatorItem();
  const cmsHeaderItems = useCmsHeaderItems();
  const { t } = useTranslation();
  const whatsAppContactButtonConfig = cmsHeaderItems?.whatsAppContactButton;

  const whatsAppContactButton = {
    iconVisible: whatsAppContactButtonConfig?.iconVisible ?? true,
    whatsAppText: whatsAppContactButtonConfig?.whatsAppText?.trim()
      ? whatsAppContactButtonConfig.whatsAppText
      : t('navbar.message_us_on_whatsapp', 'Message Us On WhatsApp 24/7'),
  };

  if (cmsHeaderItems) {
    const navbarItems = [...cmsHeaderItems.menuItems, myESIM];
    const burgerMenuItems = [
      ...cmsHeaderItems.menuItems,
      ...cmsHeaderItems.contactBarItems,
      myESIM,
    ];

    if (cmsHeaderItems.showLoginOrMyAccount) {
      navbarItems.push(myAccount);
      burgerMenuItems.push(myAccount);
    }

    return {
      navbarItems,
      burgerMenuItems,
      contactBarItems: cmsHeaderItems.contactBarItems,
      brandLogo: cmsHeaderItems.brandLogo,
      whatsAppContactButton,
    };
  }

  return {
    navbarItems: [aboutUsItem, myESIM, myAccount],
    burgerMenuItems: [aboutUsItem, helpItem, storeLocator, myESIM, myAccount],
    contactBarItems: [helpItem],
    whatsAppContactButton,
  };
};
